// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.basic-layout {
  background-color: #ffffff;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
@supports (min-height: 100dvh) {
  .basic-layout {
    min-height: 100dvh;
  }
}
.basic-layout-content {
  max-width: 576px;
  width: 100%;
  flex: 1;
  min-height: 0;
}
/*# sourceMappingURL=BasicLayout.css.map */`, "",{"version":3,"sources":["webpack://./BasicLayout.less","webpack://./src/layouts/BasicLayout.less"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;ACCD;ADEA;EACC;IACC,kBAAA;ECAA;AACF;ADGA;EACC,gBAAA;EACA,WAAA;EACA,OAAA;EACA,aAAA;ACDD;AACA,0CAA0C","sourcesContent":[".basic-layout {\n\tbackground-color: #ffffff;\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-direction: column;\n}\n\n@supports (min-height: 100dvh) {\n\t.basic-layout {\n\t\tmin-height: 100dvh;\n\t}\n}\n\n.basic-layout-content {\n\tmax-width: 576px;\n\twidth: 100%;\n\tflex: 1;\n\tmin-height: 0;\n}\n",".basic-layout {\n  background-color: #ffffff;\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n@supports (min-height: 100dvh) {\n  .basic-layout {\n    min-height: 100dvh;\n  }\n}\n.basic-layout-content {\n  max-width: 576px;\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n}\n/*# sourceMappingURL=BasicLayout.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
